// extracted by mini-css-extract-plugin
export var container = "_iz-0";
export var content = "_iz-3";
export var customerTitle = "_iz-4";
export var empty = "_iz-5";
export var gray = "_iz-6";
export var header = "_iz-7";
export var info = "_iz-8";
export var loading = "_iz-2";
export var loadingCard = "_iz-9";
export var oneLine = "_iz-a";
export var personName = "_iz-e";
export var pillContainer = "_iz-b";
export var selected = "_iz-1";
export var text = "_iz-c";
export var twoLines = "_iz-d";
export var unread = "_iz-f";
export var unreadIndicator = "_iz-g";